<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters,mapActions,mapState } from "vuex"
// import { ModelListSelect } from "vue-search-select";
import Swal from "sweetalert2";
import moment from "moment";
import DataTable from "@/components/DataTable.vue";


/**
 * Advanced table component
 */
export default {
  page: {
    title: "Stock Transfers",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    DataTable,
  },

  data() {
    return {
      title: "Stock Transfers",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Stock Transfers Report",
          active: true,
        },
      ],
      filterData:{
        dateto:moment(new Date()).format("YYYY-MM-DD"),
        datefrom:'',
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      totalRows: 1,
      filterTitle: "Stock Transfer Report",
      pageOptions: [10, 25, 50, 100, 200, 1000],
      IsStockTransfersDetailsServerPaginated:true,
      serverPerPage:50,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      filteredReport:[],
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product",
          sortablep: true,
          label: "PRODUCT",
        },
        {
          key: "source",
          sortable: true,
          label: "SOURCE",
        },
        {
          key: "source_type",
          sortable: true,
          label: "SOURCE TYPE",
        },
        {
          key: "destination",
          sortable: true,
          label: "DESTINATION",
        },
        {
          key: "qty_sent",
          sortable: true,
          label: "QUANTITY SENT",
        },
        {
          key: "qty_received",
          sortable: true,
          label: "QUANTITY RECEIVED",
        },
        {
          key: "unit",
          sortable: true,
          label: "UNITS",
        },
        {
          key: "transfer.sentOn",
          sortable: true,
          label: "SENT ON",
        },      
        {
          key: "receivedby",
          sortable: true,
          label: "RECEIVED BY",
        },
        {
          key: "status",
          sortable: true,
          label: "STATUS",
        }
      ],
      json_fields: {
        PRODUCT: "product",
        SOURCE: "source",
        SOURCE_TYPE: "source_type",
        DESTINATION: "destination",
        QUANTITY_SENT: "qt_rcv",
        QUANTITY_RECEIVED: "qty_received",
        UNITS: "unit",
        SENT_ON: "transfer.sentOn",
        RECEIVED_BY: "receivedby",
        RECEIVED_ON: "receivedOn",
        STATUS: "status",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      data: {
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
      },

    };
  },

  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("stocktransfer", ["SaveStatus","StockTransfersDetails","StockTransfersDetailsPaginated","StockTransfersDetailsPagination","StockTransfersDetailsSummary","filterStatus"]),
    ...mapGetters("general", ["BusinessSettings"]),

     rows() {
      return this.IsStockTransfersDetailsServerPaginated
        ? this.StockTransfersDetailsPagination?.total
        : this.StockTransfersDetails
        ? this.StockTransfersDetails.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsStockTransfersDetailsServerPaginated) {
          return (
            this.StockTransfersDetailsPagination.per_page ||
            this.data.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsStockTransfersDetailsServerPaginated) {
          this.data.per_page = value;
          this.data.page = 1;
          this.FetchTransfers(this.data);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.StockTransfersDetailsPaginated &&
          this.StockTransfersDetailsPagination
          ? this.StockTransfersDetailsPagination.current_page
          : 1;
      },
      set(value) {
        if (this.StockTransfersDetailsPaginated) {
          this.data.page = value;
          this.handlePageChange(value);
        }
      },
    },

    totals() {
      return (
        this.StockTransfersDetailsSummary || {
          totalStockValue: 0,
        }
      );
    },
  },
  
  updated() {
    this.FetchfilteredData();
  },

  methods: {
    ...mapActions({
      FetchTransfers: "stocktransfer/fetchStockTransfersDetails",
    }),
    
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    FetchfilteredData(){
      this.filteredReport = this.StockTransfersDetails;
    },

    filterReport(){
    this.FetchTransfers(this.data);

    
    }

  },

  watch: {
    StockTransfersDetails(newValue){
      if(newValue){
        this.FetchfilteredData();
      }
    },
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
            this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },

  created() {
    this.FetchTransfers(this.data);
    this.FetchfilteredData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div v-if="filterTitle">
                <h4>
                  <center>{{ filterTitle }}</center>
                </h4>
              </div>
              <div class="col-3">
                <download-excel
                  class="btn btn-info mt-3"
                  :data="filteredReport"
                  :fields="json_fields"
                  :worksheet="'STOCK_TRANSFER REPORT FOR' + currentdate"
                  type="csv"
                  :name="'Stocktransfer_report' + currentdate + '.xls'"
                >
                  Export Excel <i class="fa fa-download"></i>
                </download-excel>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label>From</label>
                  <input
                    
                    type="date"
                    v-model="data.datefrom"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label>To</label>
                  <input
                   
                    type="date"
                    v-model="data.dateto"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
             
             
              <div class="col-md-3 mt-4">
                <button class="btn btn-primary" type="button" @click="filterReport()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="SaveStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
              
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
             
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <DataTable
                  :columns="fields"
                  :rows="StockTransfersDetails || []"
                  :total-rows="rows"
                  :pagination="StockTransfersDetailsPagination"
                  :server-pagination="IsStockTransfersDetailsServerPaginated"
                  :loading="filterStatus"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
              </DataTable>
            </div>
           
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
